import PropTypes from "prop-types";
import { Amount } from "app/components/ui/Amount/Amount";
import "./QuotationItem.scss";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { memo } from "react";

const QuotationItem = ({ description, price, isBasePrice }) => {
	const sign = price > 0 ? "+" : "-";

	return (
		<div
			className={classNames({
				"quotation-item": true,
				"quotation-item--base-price": isBasePrice,
			})}
		>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.REGULAR}
				component="p"
				className="quotation-item__description"
				data-testid="quotation-item-label"
			>
				{description}
			</Typography>

			<div className="quotation-item__price" data-testid="quotation-item-price">
				{price === 0 ? (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.REGULAR}
						component="p"
						className="quotation-item__price--offered"
					>
						<FormattedMessage id="price.detail.no.booking.fees.label" />
					</Typography>
				) : (
					<Amount
						value={Math.abs(price)}
						sign={isBasePrice ? undefined : sign}
						isBold={false}
					/>
				)}
			</div>
		</div>
	);
};

QuotationItem.propTypes = {
	description: PropTypes.string,
	price: PropTypes.number,
	isBasePrice: PropTypes.bool,
};

export default memo(QuotationItem);
